module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "c03"
    }
  })]), _c('a', {
    attrs: {
      "id": "c03"
    }
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("Sprouts and Microgreens")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Sprouts and microgreens are excellent in green smoothies and are super-nutritious. The flavors of microgreens and sprouts are surprisingly strong, so I suggest using a small amount in a smoothie in partnership with fully grown greens.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Sprouts and microgreens can be grown easily at home to supply nutritious greenery all year round. Microgreens are greens harvested as seedlings. Sprouts are germinated seeds with a very young root stem and usually pale leaves; lentil, alfalfa, and mung beans are common types of sprouts.")])]), _c('div', [_c('a', {
    attrs: {
      "id": "c03"
    }
  }), _c('a', {
    attrs: {
      "id": "h1"
    }
  })]), _c('a', {
    attrs: {
      "id": "h1"
    }
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v(" Sprouts")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("You can buy seed-sprouter kits and follow the instructions; however, I prefer to use the following method to sprout seeds myself. For small seeds, like alfalfa, start with about 2 tablespoons seeds. For larger seeds, like lentils (French puy or black beluga are best) or mung beans, start with 1/4 to 1/2 cup seeds.")]), _vm._v(" "), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("1. Cut a piece of fine netting like tulle or hosiery and fasten with a thick elastic band on top of a 1-quart glass jar.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("2. Place the seeds in the jar, fasten the netting, and soak the seeds overnight in good-quality water.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("3. In the morning, drain the liquid and rinse the seeds with cold water till the liquid is clear (you can use the soaking water to water other plants).")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("4. Let the jar sit and drain at a 45-degree angle on your dish rack. Rinse the seeds twice a day, three times if the weather is particularly warm. Avoid direct sunlight on the jars or the seeds will cook and go rancid. If the sprouts look or smell bad, throw them out and start again.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("5. Sprouts of small seeds are ready in 5 to 6 days, when the tails are about 1 inch long. Rinse the hulls off in a colander, and pop the sprouts back into the jar to turn green in natural indirect light for about a day. Sprouts of large seeds are generally ready in 3 to 5 days when the tail is 1 to 2 times the length of the seed (the hulls of large seeds need not be rinsed. Spread the sprouts in a colander and leave to turn green in natural, indirect light for a day.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("6. When the sprouts are ready, store them in the refrigerator in a container that can breathe a bit. Eat within a few days.")]), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Alfalfa is Arabic for “father of all foods.” It is one of Dr. Gillian McKeith’s top-12 superfoods. She says alfalfa contains all the necessary nutrients for life, nourishes the blood, aids nutrient absorption, deodorizes the body, improves digestion, and is good for recovery after childbirth and for improving quality of breast milk.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Some sources call for sprouting to be in a dark place such as a cupboard to mimic the dark conditions of a seed germinating  under the soil. I have found this not to be necessary, but I have experimented with covering my sprout jars with a tea towel or dish towel while they drain, and I believe my sprouts grow more quickly this way. I uncover them for the last day so they green up.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Lentils have the second highest protein content in a legume (after soy). They aid kidney and adrenal function due to good B vitamin content particularly, vitamin B1 and folate. They are also a good source of iron, phosphorus, and manganese and are a complete protein once sprouted.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Mung bean sprouts are well-known in Asian food dishes and are grown commercially under pressure and in the absence of light to create 2- to 3-inch tails with pale yellow leaves. When they are sprouted at home, they will still contain the green hull and have a short, stumpy tail. They are a good source of vitamin C, vitamin K, folate, manganese, and copper.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Before sprouting, check for small stones in seeds such as lentils, and check for mung beans that remain hard despite the sprouting process. You don’t want to find one the hard way and chip a tooth!")])]), _c('div', [_c('a', {
    attrs: {
      "id": "h1"
    }
  }), _c('a', {
    attrs: {
      "id": "h2"
    }
  })]), _c('a', {
    attrs: {
      "id": "h2"
    }
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v(" Microgreens")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Microgreens have larger stems than sprouts do, and clear leaf development with green leaves. They are harvested by cutting the leaves away from the root when they are 1 to 2 inches tall. Microgreens are grown in 1 to 3 weeks on soil or a soil substitute. Common microgreens are are wheatgrass, sunflower shoots, and cress. Basil, beet, and cilantro microgreens are very popular in restaurants for adding subtle flavor and garnish to dishes.")]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("Items you’ll need:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Seeds, preferably untreated and nonirradiated")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Wide and shallow containers with drainage—these can be decorative ceramic dishes, seedling trays, or produce baskets with holes poked in the bottom")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Good-quality potting soil")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Cotton or paper towels")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Plastic or glass covers")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Water")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("To grow microgreens:"), _c('div', {
    staticClass: "liste"
  }, [_c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Sprinkle seeds in a dense layer over potting soil in a container. (Soak any large seeds, like peas and sunflower seeds overnight before planting.)")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Cover the seeds with a light layer of the same soil mix, or place a damp cotton or paper towel over the seeds.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Carefully water the seeds so as not to disturb them, like with a spray bottle. Cover the container with plastic or glass to create a greenhouse effect.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Keep the seeds out of direct sunlight to avoid excessive heat. Microgreens can be grown outside in a protected spot or indoors, depending on available space and the temperature.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Keep the seeds moist by watering 1 to 2 times daily. A spray bottle works well for watering gently.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Keep the seeds covered until they germinate and start lifting the cotton or paper cover, or push through the soil coverage. Then remove the coverings and expose the germinated seeds to light and air. The greens will be ready to harvest in 7 to 21 days, depending on the  variety. To harvest, cut the baby plant stem off the root above the soil level.")]), _c('div', {
    staticClass: "lsl1"
  }, [_vm._v("• Ideally, use immediately after gently rinsing, or store in a zip-top bag or sealed container in the refrigerator for a day or two.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Growing microgreens and sprouts is great fun and makes the nutritious greenery for salad, garnishes, and green smoothies available to just about anyone. For those who are serious about growing microgreens and sprouts regularly, I recommend finding one or two books and websites to aid with troubleshooting and mastering a variety of greens. In her book "), _c('i', [_vm._v("Microgreens: How to Grow Nature’s Own Superfood")]), _vm._v(", microgreens expert Fionna Hill details the ideal conditions for growing amaranth, arugula, basil, beet, broccoli, cabbage, chives, clover, corn, cress, fennel, fenugreek, flaxseed, kale, mizuna, mustard, parsley, peas, radish, and wheatgrass.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa63e310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kris_9781569759998_oeb_c03_r1.vue
// module id = 78
// module chunks = 0